// extracted by mini-css-extract-plugin
export default {"container":"Backoffice_container__hImnI","shorterNavbar":"Backoffice_shorterNavbar__trZLh"};